import { useSelector, } from 'react-redux';
import { IGlobalStore, IReducerStore, } from '@Store';

export const useKeyPressed = (): IGlobalStore['key_pressed'] => {
  return useSelector((store: IReducerStore) => store.global.key_pressed);
};
